<template>
  <span ref="fitbox" class="fit-in-string-wrap">
    <popper ref=popper
            trigger="hover"
            placement="cursor-bottom-start"
            :arrow-size="8"
            :delay-on-mouse-over="800"
            boundaries-selector="body"
            :disabled="stringIsShort"
            :touchable="touchable"
            :boundaries-padding="12">
      <template v-slot:reference>
        <span ref="str" class="fit-in-string">
          {{originalString}}
        </span>
        <span ref="original" class="hidden">
          <slot/>
        </span>
      </template>
      <span class="popper-content">{{originalString}}</span>
    </popper>
  </span>
</template>

<script>
import { mapState } from 'vuex'
import Popper from './Popper.js.vue'
export default {
  name: 'FitInString',
  components: { Popper },
  props: {},

  data: () => ({
    originalString: '',
    observer: null,
    stringIsShort: false
  }),

  computed: {
    ...mapState(['touchable'])
  },

  mounted () {
    this.$refs.fitbox.addEventListener('mouseenter', e => {
      const { width: boxWidth } = e.target.getBoundingClientRect()
      const { width } = this.$refs.str.getBoundingClientRect()
      this.stringIsShort = width < boxWidth
    })
    this.observer = new MutationObserver(() => {
      this.originalString = this.$refs.original ? this.$refs.original.textContent : ''
    })
    this.observer.observe(this.$refs.original, { characterData: true })
    this.originalString = this.$refs.original ? this.$refs.original.textContent : ''
  },

  destroyed () {
    if (this.observer) this.observer.disconnect()
  },

  methods: {
    popperOptions () {
      return {
        placement: 'left',
        modifiers: {
          offset: { offset: '0, 12px' },
          computeStyle: { x: 'bottom' },
          preventOverflow: {
            padding: 32,
            boundariesElement: document.getElementById('popup-player-controller')
          },
          flip: {
            boundariesElement: document.getElementById('popup-player-controller')
          },
          setHeight: {
            enabled: true,
            order: 10,
            padding: 32,
            boundariesElement: document.getElementById('popup-player-controller'),
            fn (data, options) {
              const boundH = options.boundariesElement.getBoundingClientRect().height - options.padding * 2
              if (boundH < data.offsets.popper.height) {
                data.offsets.popper.height = data.styles.height = boundH
              }
              return data
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .fit-in-string-wrap {
    /*display: block;*/
    width: 100%;
    overflow: hidden;

    .fit-in-string {
      display: inline-block;
      /*width: 100%;*/
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .hidden {
      display: none;
    }
  }
</style>
